import React from 'react'
import { logoutMe } from "../../../helpers/global_helper"
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";


const UserBlock = (props) => {

    return (
        <div className='popup-box'>
            <h4 className="title">{props.t('attention')} !</h4>
            <p> <b>{props.t('warning')}!</b> <br />
                {props.t('your_user_id_blocked')}.{props.t('please_contact_out_operator_via_livechat')}
            </p>
            <button onClick={logoutMe}>{props.t('okay')}</button>
        </div>
    )
}

UserBlock.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(UserBlock);